// Regras puras do agente de IA no ticket. Espelham o helper do backend
// (backend/src/helpers/ResolveAgentForTicket.ts: escolheAgente,
// temMenuNaConexao e a regra "chatbot da fila atual vence") para a tela de
// atendimento mostrar o mesmo que o servidor decide.
import { conexaoTemMenu } from "../../components/PromptModal/vinculoRules";

const temValor = (v) => v !== null && v !== undefined && v !== "";
const mesmoId = (a, b) => temValor(a) && temValor(b) && Number(a) === Number(b);

const temChatbot = (fila) =>
  Number(fila?.chatbotCount) > 0 ||
  (Array.isArray(fila?.chatbots) && fila.chatbots.length > 0);

// Agente "antes da distribuição" (Whatsapps.promptId), só em conexão sem
// menu. Conexão desconhecida → não dá para saber o menu.
const temAgenteAntesDaFila = ({ ticket, lista, whatsapp }) => {
  if (!whatsapp || !mesmoId(whatsapp.id, ticket.whatsappId)) return false;
  if (!temValor(whatsapp.promptId) || conexaoTemMenu(whatsapp)) return false;
  return lista.some((p) => mesmoId(p.id, whatsapp.promptId));
};

/**
 * O ticket tem agente? `prompts` vem de GET /prompt?all=true
 * ({ id, whatsappId, queueIds, atendeAntesDaFila }); `whatsapp` é a conexão
 * do ticket com as filas já completadas com chatbotCount; `filas` (opcional)
 * são as filas da empresa (GET /queue), para a fila atual fora da conexão.
 */
export const temAgenteNoTicket = ({ ticket, prompts, whatsapp, filas }) => {
  if (!ticket) return false;
  const lista = Array.isArray(prompts) ? prompts : [];

  if (temValor(ticket.queueId)) {
    const filaAtual =
      (whatsapp?.queues || []).find((q) => mesmoId(q.id, ticket.queueId)) ||
      (filas || []).find((q) => mesmoId(q.id, ticket.queueId));
    // Fila atual com opções de chatbot: o chatbot responde, não o agente.
    if (temChatbot(filaAtual)) return false;

    const daFila = lista.filter((p) =>
      (Array.isArray(p.queueIds) ? p.queueIds : []).some((id) =>
        mesmoId(id, ticket.queueId)
      )
    );
    if (daFila.some((p) => mesmoId(p.whatsappId, ticket.whatsappId))) return true;
    if (daFila.some((p) => !temValor(p.whatsappId))) return true;
    // Fila sem vínculo: cai no agente "antes da distribuição" se a conexão
    // não tem menu (a fila única é atribuída antes de o agente responder) e
    // a fila é da própria conexão — fila de fora (transferência) não herda.
    const filaDaConexao = (whatsapp?.queues || []).some((q) =>
      mesmoId(q.id, ticket.queueId)
    );
    if (!filaDaConexao) return false;
    return temAgenteAntesDaFila({ ticket, lista, whatsapp });
  }

  return temAgenteAntesDaFila({ ticket, lista, whatsapp });
};

/**
 * IA ligada no ticket: tem agente e não foi desligada. Aceitar o ticket
 * ("open") não desliga — quem desliga é a mensagem do atendente
 * (agentDisabled), como no portão do backend.
 */
export const iaAtivaNoTicket = ({ ticket, temAgente }) =>
  Boolean(ticket) &&
  Boolean(temAgente) &&
  !ticket.agentDisabled &&
  ticket.status !== "closed" &&
  ticket.status !== "nps" &&
  ticket.status !== "lgpd";
